import React, { Component } from "react";

import { Map, GoogleApiWrapper, Marker  } from 'google-maps-react';


const mapStyles = {

  width: '50%',

  height: '50%'

};


class Mapinfo extends Component {
   
  constructor() {

    super();

    this.state = {

      name: "React",


    };

  }
  

  


  render() {
      

    return (

      <div>

        <Map

          google={this.props.google}
          
          zoom={14}

          style={mapStyles}

          initialCenter={{

            lat: 40.854885,
            lng: -88.081807

          }}

        >

         <Marker

          onClick={this.onMarkerClick}

          name={'This is test name'}

        />

        </Map>

      </div>

    );

  }

}


export default GoogleApiWrapper({

  apiKey: 'AIzaSyDCDCEXLhqk7UKW8QG0gd8Q6E7brwxVAcE'

})(Mapinfo);